import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useRef, useState } from "react";
// import { list_comment, orgAuthorization, organizationStepAccept, sendComment, sendCommentNew } from "../../../api/apiHandler";
import { list_comment, orgAuthorization, organizationStepAccept, sendComment, sendCommentNew, approveRejectOrgLocationChange } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { TOAST_ERROR, TOAST_SUCCESS, TOAST_WARNING } from "../../../utils/common.service";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useFormik } from "formik";
import FileModal from "../../../components/FileModal";
import DataTable from "react-data-table-component";
import customStyles from "../../../utils/dataTableStyles";

export default function OAuthorization({ isLoader }) {

    const [data, setData] = useState([])
    const [commentsList, setCommentsList] = useState([]);
    console.log('commentsList :', commentsList);
    const [isCommentSent, setIsCommentSent] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    const orgId = (location.state && location.state.orgId) || new URLSearchParams(location.search).get('orgId');
    const email = (location.state && location.state.email) || new URLSearchParams(location.search).get('email');
    const name = (location.state && location.state.orgname) || new URLSearchParams(location.search).get('orgname');

    const GetOrgAuthorization = () => {
        isLoader(true)
        orgAuthorization({ org_id: orgId }).then((response) => {
            console.log('orgAuthorization :', response);
            if (response.code == 1) {
                setData(response.data)
                isLoader(false)
            } else {
                setData([])
                isLoader(false)
            }
        })
    }

    const GetOrgApplicationComments = async () => {
        try {
            isLoader(true);
            const response = await list_comment({ comment_id: orgId, action_type: "800" });
            console.log('response :', response);
            if (response.code == 1) {
                const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                setCommentsList(dataWithRowCount);
            } else if (response.code == 0) {
                TOAST_ERROR(response.message);
            }
        } catch (error) {
            console.log('error :', error);
            TOAST_ERROR(error);
        } finally {
            isLoader(false);
        }
    };

    const columns = [
        {
            name: 'No',
            selector: row => row.count,
            sortable: false,
            width: "70px"
        },
        {
            name: "Date",
            selector: row => {
                const date = new Date(row.created_at);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const formattedMonth = month < 10 ? `0${month}` : month;
                const formattedDay = day < 10 ? `0${day}` : day;
                const year = date.getFullYear();
                return `${formattedDay}-${formattedMonth}-${year}`;
            },
            sortable: true,
        },
        {
            name: "Admin name",
            selector: row => row.admin_name,
            sortable: true,
        },
        {
            name: "Comment",
            selector: row => row.comment,
            sortable: true,
        },
    ]

    useEffect(() => {
        GetOrgAuthorization();
        GetOrgApplicationComments();
    }, []);

    const handleBack = () => {
        navigate(-1);
    };

    const handleAccpet = () => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to accept organization authorization?",
            showCancelButton: true,
            confirmButtonText: "Accept",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    var objAccept = {
                        org_id: orgId,
                        email: email,
                        accept: "2",
                        step: "4",
                        org_name: name
                    };
                    isLoader(true)
                    organizationStepAccept(objAccept).then((response) => {
                        if (response.code == 1) {
                            TOAST_SUCCESS(response.message);
                            setData(prevData => ({ ...prevData, step_4: "2" }));
                            isLoader(false)
                        } else {
                            TOAST_ERROR(response.message);
                            isLoader(false)
                        }
                    });
                } catch (error) {
                    TOAST_ERROR("Error..!!")
                }
            }
        });
    }

    const handleReject = () => {
        if (!isCommentSent) {
            TOAST_WARNING("Please send your comment first before rejecting.");
            return;
        }

        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to reject organization authorization?",
            showCancelButton: true,
            confirmButtonText: "Reject",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    var objReject = {
                        org_id: orgId,
                        email: email,
                        accept: "3",
                        step: "4",
                        org_name: name
                    };
                    isLoader(true)
                    organizationStepAccept(objReject).then((response) => {
                        if (response.code == 1) {
                            TOAST_SUCCESS(response.message);
                            setData(prevData => ({ ...prevData, step_4: "3" }));
                            setIsCommentSent(false);
                            isLoader(false)
                        } else {
                            TOAST_ERROR(response.message);
                            isLoader(false)
                        }
                    });
                } catch (error) {
                    TOAST_ERROR("Error..!!")
                }
            }
        });
    }

    const handleAcceptLocationChange = () => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to accept the requested address change?",
            text: "The approved in-person location address will be replaced with the requested address.",
            showCancelButton: true,
            confirmButtonText: "Accept",
        }).then((result) => {
            if (result.isConfirmed) {
                isLoader(true);
                approveRejectOrgLocationChange({
                    request_id: data.pending_change_request.id,
                    org_id: orgId,
                    action: "accept",
                    email: email,
                    org_name: name
                }).then((response) => {
                    isLoader(false);
                    if (response.code == 1) {
                        TOAST_SUCCESS(response.message);
                        GetOrgAuthorization();
                    } else {
                        TOAST_ERROR(response.message);
                    }
                }).catch(() => {
                    isLoader(false);
                    TOAST_ERROR("Error..!!");
                });
            }
        });
    }

    const handleRejectLocationChange = () => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to reject the requested address change?",
            input: "textarea",
            inputLabel: "Reject reason",
            inputPlaceholder: "Enter the reason for rejection...",
            showCancelButton: true,
            confirmButtonText: "Reject",
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return "Please enter the reject reason.";
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                isLoader(true);
                approveRejectOrgLocationChange({
                    request_id: data.pending_change_request.id,
                    org_id: orgId,
                    action: "reject",
                    reject_reason: result.value.trim(),
                    email: email,
                    org_name: name
                }).then((response) => {
                    isLoader(false);
                    if (response.code == 1) {
                        TOAST_SUCCESS(response.message);
                        GetOrgAuthorization();
                    } else {
                        TOAST_ERROR(response.message);
                    }
                }).catch(() => {
                    isLoader(false);
                    TOAST_ERROR("Error..!!");
                });
            }
        });
    }

    // Current (approved) vs requested data for the comparison card - every field of the onsite application
    const requested = data?.pending_change_request?.requested_data || {};
    const locationCompareFields = [
        { label: "Legally Registered Full Name", current: data?.reg_full_name, requested: requested.reg_full_name },
        { label: "Position", current: data?.position, requested: requested.position },
        { label: "Authorized To Represent The Organization", current: data?.authorized, requested: requested.authorized },
        { label: "Street Number", current: data?.street_number, requested: requested.street_number },
        { label: "Unit Number", current: data?.unit_number, requested: requested.unit_number },
        { label: "Street Name", current: data?.street_name, requested: requested.street_name },
        { label: "Country", current: data?.country_name, requested: requested.country_name },
        { label: "Province/State", current: data?.state_province_name, requested: requested.state_province_name },
        { label: "City", current: data?.city, requested: requested.city },
        { label: "Zip Code", current: data?.zip_code, requested: requested.zip_code },
        { label: "Operating As Per Laws And Regulations", current: data?.physical_location, requested: requested.physical_location },
        { label: "Google My Business Account", current: data?.google_business, requested: requested.google_business },
        { label: "Google My Business URL", current: data?.business_url, requested: requested.business_url },
        { label: "Social Media Accounts", current: data?.social_media_account, requested: requested.social_media_account },
    ];
    const fileName = (url) => String(url || "").split("/").pop();
    const currentInside = (data?.attachments?.attachment_inside || []).map((item) => item?.attachments?.[0]?.attachment).filter(Boolean);
    const currentOutside = (data?.attachments?.attachment_outside || []).map((item) => item?.attachments?.[0]?.attachment).filter(Boolean);
    const requestedInside = requested.attachment_urls?.inside || [];
    const requestedOutside = requested.attachment_urls?.outside || [];
    const sameFiles = (a, b) => JSON.stringify(a.map(fileName).sort()) === JSON.stringify(b.map(fileName).sort());

    const formatAddress = (item) => [
        [item?.street_number, item?.street_name].filter(Boolean).join(" "),
        item?.unit_number ? `Unit ${item.unit_number}` : "",
        item?.city,
        item?.state_province_name,
        item?.country_name,
        item?.zip_code,
    ].filter(Boolean).join(", ");

    const fileInputs = useRef([]);
    const resetFileInputs = () => {
        fileInputs.current.forEach((input) => {
            input.value = '';
        });
    };

    const commentSchema = Yup.object({
        comment: Yup.string()
    });

    const commentForm = useFormik({
        initialValues: {
            comment: '',
        },
        validationSchema: commentSchema,

        onSubmit: async (commentData) => {
            if (commentData.comment.trim() != "") {
                commentData.action_id = data.id
                commentData.action_type = "800"
                commentData.id = orgId;
                commentData.email = email;
                commentData.comment_for = 2; //comment_for 1 = teacher , 2 = organization , 3 = organization_teacher
                commentData.step = 4;
                commentData.name = name
                isLoader(true)
                sendCommentNew(commentData).then((response) => {
                    if (response.code == 1) {
                        TOAST_SUCCESS(response.message);
                        commentForm.resetForm();
                        resetFileInputs();
                        setIsCommentSent(true);
                        GetOrgAuthorization();
                        GetOrgApplicationComments();
                        isLoader(false)
                    } else {
                        TOAST_ERROR(response.message);
                        isLoader(false)
                    }
                });
            }
        },
    });

    const displayError = (fieldName) =>
        commentForm.touched[fieldName] && commentForm.errors[fieldName];

    const [selectedFile, setSelectedFile] = useState(null);
    const [docModal, setDocModal] = useState(false);

    const openModal = (url) => {
        setSelectedFile(url);
        setDocModal(true);
    };

    const closeModal = () => {
        setSelectedFile(null);
        setDocModal(false);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <header className="dashboard-toolbar d-lg-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
                <div className="d-flex align-items-center">
                    <a className="menu-toggle align-items-center d-lg-none d-flex">
                        <i className="fa fa-bars" />
                    </a>
                    <a href="index.php" className="d-lg-none d-block brand-logo">
                        <img src="./assets/images/logo.png" alt="logo" />
                    </a>
                </div>
            </div>
        </header>
        <section className="main_sec">
            <div className="mt-4 mx-5 mb-5">
                <div>
                    <span onClick={handleBack}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                </div>

                {(Object.keys(data).length > 0 ? (
                    <>
                        <p className="ms-3 fs-3 fw-500 text-center mb-3">Authorization to teach In-person</p>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col col-lg-8 mb-4 mb-lg-0">
                                <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                    <div className="row g-0">
                                        <div className="col-md-12">
                                            <div className="card-body p-4">
                                                <p className="mb-2 fs-5 fw-600">Information</p>
                                                <hr className="mt-0 mb-4" />
                                                <div className="row pt-1">
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Legally Registered Full Name</p>
                                                        <p className="text-muted mt-1">{data?.reg_full_name}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500"> Position That You Hold In The Organzation</p>
                                                        <p className="text-muted mt-1">{data?.position}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Please Confirm If You Are Authorized To Represent The Organization.</p>
                                                        <p className={`${data?.authorized == "No" ? "text-danger" : "text-muted"} mt-1`}>{data?.authorized}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">The Address Of The Legally Authorized Location Of Your Organization In Which That You Will Provide Lessons At.</p>
                                                    </div>
                                                    <div className="col-6 mb-4">
                                                        <p className="fw-500">Street Number</p>
                                                        <p className="text-muted mt-1">{data?.street_number}</p>
                                                    </div>
                                                    <div className="col-6 mb-4">
                                                        <p className="fw-500">Unit Number</p>
                                                        <p className="text-muted mt-1">{data?.unit_number || "-"}</p>
                                                    </div>
                                                    <div className="col-6 mb-4">
                                                        <p className="fw-500">Street Name</p>
                                                        <p className="text-muted mt-1">{data?.street_name}</p>
                                                    </div>
                                                    <div className="col-6 mb-4">
                                                        <p className="fw-500">Country</p>
                                                        <p className="text-muted mt-1">{data?.country_name}</p>
                                                    </div>
                                                    <div className="col-6 mb-4">
                                                        <p className="fw-500">Province/State</p>
                                                        <p className="text-muted mt-1">{data?.state_province_name}</p>
                                                    </div>
                                                    <div className="col-6 mb-4">
                                                        <p className="fw-500">City</p>
                                                        <p className="text-muted mt-1">{data?.city}</p>
                                                    </div>
                                                    <div className="col-6 mb-4">
                                                        <p className="fw-500">Zip Code</p>
                                                        <p className="text-muted mt-1">{data?.zip_code}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Please Confirm If The Physical Location/Business Is Operating Meeting The Guidelines As Per The Laws And Regulations Of Your City/Country.</p>
                                                        <p className={`${data?.physical_location == "No" ? "text-danger" : "text-muted"} mt-1`}>{data?.physical_location}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Do You Have A Google My Business Account ?</p>
                                                        <p className={`${data?.google_business == "No" ? "text-danger" : "text-muted"} mt-1`}>{data?.google_business}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Google My Business Account URL Link</p>
                                                        <p className="text-muted mt-1">{data?.business_url}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Please Share Any Social Media Accounts That Shows Your Business Location</p>
                                                        <p className="text-muted mt-1">{data?.social_media_account}</p>
                                                    </div>
                                                    <div className="col-12 mb-4">
                                                        <p className="fw-500">Please Upload A Liability Insurance Document To Confirm That Your Organization Is Insured</p>
                                                        {/* {data.insurance_document && (
                                                            <a href={data?.insurance_document} className="text-purple underline mt-1">View Document</a>
                                                        )} */}
                                                        {data.insurance_document && (
                                                            <a onClick={() => openModal(data.insurance_document)} className="text-purple underline mt-1">View Document</a>
                                                        )}
                                                    </div>
                                                    {data?.attachments?.attachment_inside.length > 0 && <>
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-500 mb-3">Pictures Indside</p>
                                                            <img src={data?.attachments?.attachment_inside[0]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                            <img src={data?.attachments?.attachment_inside[1]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                            <img src={data?.attachments?.attachment_inside[2]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                            <img src={data?.attachments?.attachment_inside[3]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                            <img src={data?.attachments?.attachment_inside[4]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                            <img src={data?.attachments?.attachment_inside[5]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                        </div>
                                                    </>}
                                                    {data?.attachments?.attachment_outside.length > 0 && <>
                                                        <div className="col-12 mb-4">
                                                            <p className="fw-500 mb-3">Pictures Outside</p>
                                                            <img src={data?.attachments?.attachment_outside[0]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                            <img src={data?.attachments?.attachment_outside[1]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                            <img src={data?.attachments?.attachment_outside[2]?.attachments[0]?.attachment} className="media-thumb text-muted mt-1 mx-1 my-1" />
                                                        </div>
                                                    </>}


                                                    {/* <div className="col-12 mb-4">
                                                        <p className="fw-500">Admin Comments</p>
                                                        <p className="text-muted mt-1">{data.comments}</p>
                                                    </div> */}
                                                </div>

                                                <form className="custom_form mt-4" name="commentForm" onSubmit={commentForm.handleSubmit}>

                                                    <div className="form-group mb-4">
                                                        <p className="fw-500 mb-2">Any comments you have, please add them here for the teacher.</p>
                                                        <textarea type="text" className="form-control" name="comment" value={commentForm.values.comment} rows="5" cols="33" onChange={commentForm.handleChange} ></textarea>
                                                        {displayError("comment") && (
                                                            <div className="text-danger">{commentForm.errors.comment}</div>
                                                        )}
                                                        <div className="button mt-2 mb-2 d-flex justify-content-end">
                                                            <button type="submit" className="btn-theme px-4 py-2  text-center text-dif-black fw-500 bg-yellow mb-xl-0 mb-3 d-inline-block">Send</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                {(data.step_4 == 0 || data.step_4 == 1) &&
                                                    <div className="d-flex justify-content-center mt-3">
                                                        <button className="btn-theme bg-yellow mx-1" onClick={() => handleAccpet()}>
                                                            {data.step_4 == "2" ? "Accepted" : "Accept"}
                                                        </button>
                                                        <button className="btn-theme mx-1" onClick={() => handleReject()}>
                                                            {data.step_4 == "3" ? "Rejected" : "Reject"}
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {data?.pending_change_request && (
                                    <div className="card mb-3 p-3 border-warning" style={{ borderRadius: ".5rem", borderWidth: "2px" }}>
                                        <div className="card-body p-4">
                                            <h6 className="mb-2 text-warning fw-bold">Requested In-person Location Changes — Pending Review</h6>
                                            <p className="text-muted mb-3" style={{ fontSize: "0.875rem" }}>
                                                Requested On: {new Date(data.pending_change_request.created_at).toLocaleDateString('en-GB')}
                                            </p>
                                            <hr className="mt-0 mb-4" />
                                            <div className="row pt-1 fw-600 mb-2">
                                                <div className="col-4">Field</div>
                                                <div className="col-4">Current (Approved)</div>
                                                <div className="col-4">Requested</div>
                                            </div>
                                            {locationCompareFields.map((field) => {
                                                const isChanged = String(field.current ?? "").trim() !== String(field.requested ?? "").trim();
                                                return (
                                                    <div key={field.label} className="row pt-1 border-bottom pb-2 mb-2">
                                                        <div className="col-4 fw-500">{field.label}</div>
                                                        <div className="col-4 text-muted">{field.current || "-"}</div>
                                                        <div className={`col-4 ${isChanged ? "fw-600 text-danger" : "text-muted"}`}>{field.requested || "-"}</div>
                                                    </div>
                                                );
                                            })}
                                            <div className="row pt-1 border-bottom pb-2 mb-2">
                                                <div className="col-4 fw-500">Liability Insurance Document</div>
                                                <div className="col-4">
                                                    {data?.insurance_document ? <a onClick={() => openModal(data.insurance_document)} className="text-purple underline" style={{ cursor: "pointer" }}>View Document</a> : "-"}
                                                </div>
                                                <div className={`col-4 ${fileName(data?.insurance_document) !== fileName(requested.insurance_document) ? "fw-600 text-danger" : ""}`}>
                                                    {requested.insurance_document ? <a onClick={() => openModal(requested.insurance_document)} className="text-purple underline" style={{ cursor: "pointer" }}>View Document</a> : "-"}
                                                    {fileName(data?.insurance_document) !== fileName(requested.insurance_document) && <span className="ms-2">(Changed)</span>}
                                                </div>
                                            </div>
                                            {[
                                                { label: "Pictures Inside", current: currentInside, requested: requestedInside },
                                                { label: "Pictures Outside", current: currentOutside, requested: requestedOutside },
                                            ].map((group) => (
                                                <div key={group.label} className="row pt-1 border-bottom pb-2 mb-2">
                                                    <div className="col-4 fw-500">
                                                        {group.label}
                                                        {!sameFiles(group.current, group.requested) && <span className="d-block fw-600 text-danger">(Changed)</span>}
                                                    </div>
                                                    <div className="col-4">
                                                        {group.current.length > 0 ? group.current.map((url) => (
                                                            <img key={url} src={url} alt="" className="mx-1 my-1" style={{ height: "80px", width: "80px", objectFit: "cover", cursor: "pointer" }} onClick={() => openModal(url)} />
                                                        )) : "-"}
                                                    </div>
                                                    <div className="col-4">
                                                        {group.requested.length > 0 ? group.requested.map((url) => (
                                                            <img key={url} src={url} alt="" className="mx-1 my-1" style={{ height: "80px", width: "80px", objectFit: "cover", cursor: "pointer" }} onClick={() => openModal(url)} />
                                                        )) : "-"}
                                                    </div>
                                                </div>
                                            ))}
                                            <p className="text-muted text-center mb-3 mt-3" style={{ fontSize: "0.875rem" }}>
                                                Accepting will replace the approved in-person location details (including documents and pictures) with the requested ones. Rejecting keeps the approved details unchanged.
                                            </p>
                                            <div className="d-flex justify-content-center mt-3">
                                                <button className="btn-theme bg-yellow mx-1" onClick={() => handleAcceptLocationChange()}>
                                                    Accept
                                                </button>
                                                <button className="btn-theme mx-1" onClick={() => handleRejectLocationChange()}>
                                                    Reject
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {data?.change_request_history?.length > 0 && (
                                    <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                        <div className="card-body p-4">
                                            <h6 className="mb-2 fw-bold">In-person Location Change History</h6>
                                            <hr className="mt-0 mb-4" />
                                            {data.change_request_history.map((item, index) => (
                                                <div key={item.id} className={`row pt-1 ${index < data.change_request_history.length - 1 ? "border-bottom mb-3 pb-2" : ""}`}>
                                                    <div className="col-md-3 mb-3">
                                                        <p className="fw-600">Reviewed On</p>
                                                        <p className="text-muted mt-1">{item.reviewed_at ? new Date(item.reviewed_at).toLocaleDateString('en-GB') : "-"}</p>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <p className="fw-600">Requested Address</p>
                                                        <p className="text-muted mt-1">{formatAddress(item.requested_data)}</p>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <p className="fw-600">Status</p>
                                                        <p className={`mt-1 fw-600 ${item.status === "accepted" ? "text-success" : "text-danger"}`}>
                                                            {item.status === "accepted" ? "Accepted" : "Rejected"}
                                                        </p>
                                                    </div>
                                                    {item.status === "rejected" && item.reject_reason && (
                                                        <div className="col-12 mb-3">
                                                            <p className="fw-600">Reject Reason</p>
                                                            <p className="text-muted mt-1" style={{ whiteSpace: "pre-wrap" }}>{item.reject_reason}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {commentsList?.length > 0 && (
                                    <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                        <div className="row g-0">
                                            <div className="col-md-12">
                                                <div className="card-body p-4">
                                                    <DataTable
                                                        persistTableHead
                                                        columns={columns}
                                                        data={commentsList}
                                                        pagination
                                                        customStyles={customStyles}
                                                        className="custom-data-table"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <div>
                        <p className="text-center fs-5 fw-500 text-danger mt-5">The Organization has not filled out the authorization form.</p>
                    </div>
                )
                )}

            </div>
        </section >

        {docModal && <FileModal isOpen={docModal} fileUrl={selectedFile} onClose={closeModal} />}
    </>
}

